var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn" },
    [
      _c(
        "b-col",
        { attrs: { xl: "4", md: "6", "offset-xl": "4", "offset-md": "3" } },
        [
          _c(
            "b-card",
            {
              attrs: {
                "bg-variant": "light",
                "header-tag": "h5",
                header: _vm.$t("ACCOUNT.ADD_NEW"),
                "header-class":
                  "card-header-center card-header-primary card-header-uppercase",
                "footer-class": "card-footer-between"
              }
            },
            [
              _c(
                "b-form-group",
                [
                  _c("label", { attrs: { for: "name" } }, [
                    _vm._v(_vm._s(_vm.$t("COMMON.NAME")))
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "required" }, [_vm._v("*")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.account.name,
                        expression: "account.name"
                      }
                    ],
                    staticClass: "form-control",
                    class: {
                      "is-invalid": _vm.$v.account.name.$error,
                      "is-valid": !_vm.$v.account.name.$invalid
                    },
                    attrs: {
                      type: "text",
                      placeholder: _vm.$t("ACCOUNT.NAME")
                    },
                    domProps: { value: _vm.account.name },
                    on: {
                      blur: function($event) {
                        _vm.$v.account.name.$touch()
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.account, "name", $event.target.value)
                      }
                    }
                  }),
                  _vm._v(" "),
                  !_vm.$v.account.name.required
                    ? _c("b-form-invalid-feedback", [
                        _vm._v(_vm._s(_vm.$t("ACCOUNT.VALID_BLANK")))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.$v.account.name.isUnique
                    ? _c("b-form-invalid-feedback", [
                        _vm._v(_vm._s(_vm.$t("ACCOUNT.VALID_EXIST")))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.$v.account.name.minLen
                    ? _c("b-form-invalid-feedback", [
                        _vm._v(_vm._s(_vm.$t("ACCOUNT.VALID_MIN")))
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                [
                  _c("label", { attrs: { for: "account_type" } }, [
                    _vm._v(_vm._s(_vm.$t("ACCOUNT.ACCOUNT_TYPE")))
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "required" }, [_vm._v("*")]),
                  _vm._v(" "),
                  _c("b-form-select", {
                    staticClass: "form-control",
                    class: {
                      "is-invalid": _vm.$v.account.account_type.$error,
                      "is-valid": !_vm.$v.account.account_type.$invalid
                    },
                    attrs: { plain: true, options: _vm.account_types },
                    model: {
                      value: _vm.account.account_type,
                      callback: function($$v) {
                        _vm.$set(_vm.account, "account_type", $$v)
                      },
                      expression: "account.account_type"
                    }
                  }),
                  _vm._v(" "),
                  !_vm.$v.account.account_type.required
                    ? _c("b-form-invalid-feedback", [
                        _vm._v(_vm._s(_vm.$t("ACCOUNT.VALID_ACCOUNT_TYPE")))
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                [
                  _c("label", { attrs: { for: "ocr_engine" } }, [
                    _vm._v(_vm._s(_vm.$t("ACCOUNT.OCR_ENGINE")))
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "required" }, [_vm._v("*")]),
                  _vm._v(" "),
                  _c("b-form-select", {
                    staticClass: "form-control",
                    class: {
                      "is-invalid": _vm.$v.account.ocr_engine.$error,
                      "is-valid": !_vm.$v.account.ocr_engine.$invalid
                    },
                    attrs: { plain: true, options: _vm.ocr_engines },
                    model: {
                      value: _vm.account.ocr_engine,
                      callback: function($$v) {
                        _vm.$set(_vm.account, "ocr_engine", $$v)
                      },
                      expression: "account.ocr_engine"
                    }
                  }),
                  _vm._v(" "),
                  !_vm.$v.account.ocr_engine.required
                    ? _c("b-form-invalid-feedback", [
                        _vm._v(_vm._s(_vm.$t("ACCOUNT.VALID_OCR_ENGINE")))
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                [
                  _c("label", { attrs: { for: "expires_at" } }, [
                    _vm._v(_vm._s(_vm.$t("ACCOUNT.END_DATE")))
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "required" }, [_vm._v("*")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.account.expires_at,
                        expression: "account.expires_at"
                      }
                    ],
                    staticClass: "form-control",
                    class: {
                      "is-invalid": _vm.$v.account.expires_at.$error,
                      "is-valid": !_vm.$v.account.expires_at.$invalid
                    },
                    attrs: {
                      type: "date",
                      min: _vm.currDate,
                      value: "account.expires_at"
                    },
                    domProps: { value: _vm.account.expires_at },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.account, "expires_at", $event.target.value)
                      }
                    }
                  }),
                  _vm._v(" "),
                  !_vm.$v.account.expires_at.required ||
                  !_vm.$v.account.expires_at.isValid
                    ? _c("b-form-invalid-feedback", [
                        _vm._v(_vm._s(_vm.$t("ACCOUNT.VALID_END_DATE")))
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                [
                  _c("label", { attrs: { for: "process_categories" } }, [
                    _vm._v(_vm._s(_vm.$t("ACCOUNT.PROCESS_TYPE")))
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "required" }, [_vm._v("*")]),
                  _vm._v(" "),
                  _c("multiselect", {
                    attrs: {
                      options: _vm.processCategories,
                      multiple: true,
                      "max-height": 200
                    },
                    model: {
                      value: _vm.account.process_categories,
                      callback: function($$v) {
                        _vm.$set(_vm.account, "process_categories", $$v)
                      },
                      expression: "account.process_categories"
                    }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    staticClass: "form-control",
                    class: {
                      "is-invalid": _vm.$v.account.process_categories.$error,
                      "is-valid": !_vm.$v.account.process_categories.$invalid
                    },
                    attrs: { hidden: "" }
                  }),
                  _vm._v(" "),
                  !_vm.$v.account.process_categories.isValid
                    ? _c("b-form-invalid-feedback", [
                        _vm._v(_vm._s(_vm.$t("ACCOUNT.VALID_PROCESS_TYPE")))
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                [
                  _c("label", { attrs: { for: "process_categories" } }, [
                    _vm._v("Salesforce System")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "required" }, [_vm._v("*")]),
                  _vm._v(" "),
                  _c("multiselect", {
                    attrs: {
                      options: _vm.salesforceExternalSystems,
                      multiple: false,
                      "max-height": 200,
                      "custom-label": _vm.dropDownLabel
                    },
                    model: {
                      value: _vm.account.salesforce_system,
                      callback: function($$v) {
                        _vm.$set(_vm.account, "salesforce_system", $$v)
                      },
                      expression: "account.salesforce_system"
                    }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    staticClass: "form-control",
                    class: {
                      "is-invalid": _vm.$v.account.process_categories.$error,
                      "is-valid": !_vm.$v.account.process_categories.$invalid
                    },
                    attrs: { hidden: "" }
                  }),
                  _vm._v(" "),
                  !_vm.$v.account.process_categories.isValid
                    ? _c("b-form-invalid-feedback", [
                        _vm._v(_vm._s(_vm.$t("ACCOUNT.VALID_PROCESS_TYPE")))
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                [
                  _c("label", { attrs: { for: "process_categories" } }, [
                    _vm._v("Mulesoft System")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "required" }, [_vm._v("*")]),
                  _vm._v(" "),
                  _c("multiselect", {
                    attrs: {
                      options: _vm.mulesoftExternalSystems,
                      multiple: false,
                      "max-height": 200,
                      "custom-label": _vm.dropDownLabel
                    },
                    model: {
                      value: _vm.account.mulesoft_system,
                      callback: function($$v) {
                        _vm.$set(_vm.account, "mulesoft_system", $$v)
                      },
                      expression: "account.mulesoft_system"
                    }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    staticClass: "form-control",
                    class: {
                      "is-invalid": _vm.$v.account.process_categories.$error,
                      "is-valid": !_vm.$v.account.process_categories.$invalid
                    },
                    attrs: { hidden: "" }
                  }),
                  _vm._v(" "),
                  !_vm.$v.account.process_categories.isValid
                    ? _c("b-form-invalid-feedback", [
                        _vm._v(_vm._s(_vm.$t("ACCOUNT.VALID_PROCESS_TYPE")))
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                [
                  _c("label", { attrs: { for: "integration_emails" } }, [
                    _vm._v(_vm._s(_vm.$t("COMMON.INTEGRATION_EMAILS")))
                  ]),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.integration_emails,
                        expression: "integration_emails"
                      }
                    ],
                    staticClass: "form-control",
                    class: {
                      "is-invalid": _vm.$v.account.integration_emails.$error,
                      "is-valid": !_vm.$v.account.integration_emails.$invalid
                    },
                    attrs: {
                      placeholder: _vm.$t("COMMON.ENTER_MULTIPLE_EMAILS")
                    },
                    domProps: { value: _vm.integration_emails },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.integration_emails = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm.$v.account.integration_emails.$invalid
                    ? _c("b-form-invalid-feedback", [
                        _vm._v(_vm._s(_vm.$t("ACCOUNT.VALID_EMAIL")))
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                [
                  _c("label", { attrs: { for: "notification_emails" } }, [
                    _vm._v(_vm._s(_vm.$t("COMMON.NOTIFICATION_EMAILS")))
                  ]),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.notification_emails,
                        expression: "notification_emails"
                      }
                    ],
                    staticClass: "form-control",
                    class: {
                      "is-invalid": _vm.$v.account.notification_emails.$error,
                      "is-valid": !_vm.$v.account.notification_emails.$invalid
                    },
                    attrs: {
                      placeholder: _vm.$t("COMMON.ENTER_MULTIPLE_EMAILS")
                    },
                    domProps: { value: _vm.notification_emails },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.notification_emails = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm.$v.account.notification_emails.$invalid
                    ? _c("b-form-invalid-feedback", [
                        _vm._v(_vm._s(_vm.$t("ACCOUNT.VALID_EMAIL")))
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("b-form-group", [
                _c("label", { attrs: { for: "notification_emails" } }, [
                  _vm._v(_vm._s(_vm.$t("ACCOUNT.ACCOUNT_LOGO")))
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("input", {
                  ref: "file",
                  attrs: {
                    id: "fileUpload",
                    type: "file",
                    accept: "image/png, image/jpeg",
                    required: "true"
                  }
                }),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    on: {
                      click: function($event) {
                        _vm.removeFile()
                      }
                    }
                  },
                  [_c("i", { staticClass: "fa fa-times" })]
                )
              ]),
              _vm._v(" "),
              _c(
                "b-form-group",
                [
                  _c("c-switch", {
                    attrs: { type: "3d", variant: "success" },
                    on: {
                      change: function($event) {
                        _vm.changeAutoExportStatus($event)
                      }
                    }
                  }),
                  _vm._v(" Auto Export to Salesforce\n      ")
                ],
                1
              ),
              _vm._v(" "),
              _vm.account.salesforce_auto_export
                ? _c("b-form-group", [
                    _c("div", { staticClass: "range-slider" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.account.confidenceScore,
                            expression: "account.confidenceScore"
                          }
                        ],
                        attrs: {
                          min: "0",
                          max: "100",
                          step: "1",
                          type: "range"
                        },
                        domProps: { value: _vm.account.confidenceScore },
                        on: {
                          __r: function($event) {
                            _vm.$set(
                              _vm.account,
                              "confidenceScore",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          " Select " +
                            _vm._s(_vm.$t("FORMS.CONF_RANGE")) +
                            " : " +
                            _vm._s(_vm.account.confidenceScore) +
                            " - 100"
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "note" }, [
                      _vm._v(
                        "Note: Select Confidence Range to auto export Data to Sales force if confidence range meets the criteria. Default Range is 90-100"
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "padding-x-2",
                      attrs: {
                        type: "submit",
                        size: "sm",
                        variant: "secondary"
                      },
                      on: {
                        click: function($event) {
                          _vm.createAccount()
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fa fa-dot-circle-o" }),
                      _vm._v(" " + _vm._s(_vm.$t("COMMON.SUBMIT")) + " ")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "padding-x-2",
                      attrs: { type: "reset", size: "sm", variant: "gray" },
                      on: {
                        click: function($event) {
                          _vm.resetForm()
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fa fa-ban" }),
                      _vm._v(" " + _vm._s(_vm.$t("COMMON.RESET")) + " ")
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "errorsModal",
          attrs: {
            title: _vm.$t("ACCOUNT.ERRORS"),
            centered: "",
            "hide-footer": ""
          },
          on: { hidden: _vm.hideErrorsModal }
        },
        [
          _c("b-container", { attrs: { fluid: "" } }, [
            _c(
              "div",
              [
                _c(
                  "b-row",
                  { staticClass: "mb-1 text-center" },
                  [
                    _c("b-col", { attrs: { cols: "6" } }, [
                      _c("strong", [_vm._v(_vm._s(_vm.$t("ACCOUNT.EMAIL")))])
                    ]),
                    _vm._v(" "),
                    _c("b-col", { attrs: { cols: "6" } }, [
                      _c("strong", [_vm._v(_vm._s(_vm.$t("ACCOUNT.REASON")))])
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._l(_vm.errors, function(error, index) {
                  return _c(
                    "b-row",
                    {
                      key: error.email + index,
                      staticClass: "mb-1 text-center"
                    },
                    [
                      _c(
                        "b-col",
                        { staticClass: "warning", attrs: { cols: "6" } },
                        [_vm._v(_vm._s(error.email) + " ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "warning", attrs: { cols: "6" } },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("ACCOUNT." + error.reason)) + " "
                          )
                        ]
                      )
                    ],
                    1
                  )
                })
              ],
              2
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "logoDeleteModal",
          attrs: {
            title: _vm.$t("COMMON.DELETE_CONFIRM"),
            id: "modal-center",
            centered: "",
            "cancel-title": _vm.$t("COMMON.NO"),
            "ok-title": _vm.$t("COMMON.YES")
          },
          on: { ok: _vm.deleteFile }
        },
        [
          _c("p", { staticClass: "my-4" }, [
            _vm._v(" " + _vm._s(_vm.$t("ACCOUNT.DELETE_CONTENT")))
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a26501c4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a26501c4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/superAdmin/newAccount.vue
// module id = 1425
// module chunks = 2